const productCategories = [
  { id: 'ventanas', title: 'Ventanas de impacto', desc: 'Casement, fixed, sliding y awning.' },
  { id: 'puertas', title: 'Puertas arquitectónicas', desc: 'Pivot, french, sliding glass y multi slide.' },
  { id: 'garage', title: 'Puertas de garage', desc: 'Seccionales, full view y hurricane rated.' },
];

const getCategoryTitle = (id) =>
  productCategories.find((c) => c.id === id)?.title || id || 'Catálogo';

const designPresets = {
  ventanas: [
    {
      id: 'casement',
      title: 'Casement',
      desc: 'Apertura lateral con sello hermético.',
      image: 'https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?auto=format&fit=crop&w=600&q=80',
    },
    {
      id: 'sliding',
      title: 'Sliding',
      desc: 'Paneles corredizos para espacios reducidos.',
      image: 'https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=600&q=80',
    },
    {
      id: 'fixed',
      title: 'Fixed',
      desc: 'Panel panorámico para vistas abiertas.',
      image: 'https://images.unsplash.com/photo-1481277542470-605612bd2d61?auto=format&fit=crop&w=600&q=80',
    },
    {
      id: 'awning',
      title: 'Awning',
      desc: 'Bisagra superior para ventilar con lluvia.',
      image: 'https://images.unsplash.com/photo-1460574283810-2aab119d8511?auto=format&fit=crop&w=600&q=80',
    },
  ],
  puertas: [
    {
      id: 'pivot',
      title: 'Pivot',
      desc: 'Panel XL con herrajes ocultos.',
      image: 'https://images.unsplash.com/photo-1505692794400-2b01db48e9cc?auto=format&fit=crop&w=600&q=80',
    },
    {
      id: 'french',
      title: 'French',
      desc: 'Doble hoja con máxima iluminación.',
      image: 'https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=600&q=80&sat=-30',
    },
    {
      id: 'sliding-glass',
      title: 'Sliding Glass',
      desc: 'Corredizas reforzadas para aperturas amplias.',
      image: 'https://images.unsplash.com/photo-1460574283810-2aab119d8511?auto=format&fit=crop&w=600&q=80',
    },
    {
      id: 'multi-slide',
      title: 'Multi Slide',
      desc: 'Paneles apilables que integran interior/exterior.',
      image: 'https://images.unsplash.com/photo-1505693314120-0d443867891c?auto=format&fit=crop&w=600&q=80',
    },
    {
      id: 'entrance',
      title: 'Entrance',
      desc: 'Puertas principales a la medida.',
      image: 'https://images.unsplash.com/photo-1501183638710-841dd1904471?auto=format&fit=crop&w=600&q=80',
    },
  ],
  garage: [
    {
      id: 'seccionales',
      title: 'Seccionales',
      desc: 'Paneles termoaislados con motor inteligente.',
      image: 'https://images.unsplash.com/photo-1616593631056-0f0e687a19bd?auto=format&fit=crop&w=600&q=80',
    },
    {
      id: 'full-view',
      title: 'Full View',
      desc: 'Aluminio y cristal para showrooms.',
      image: 'https://images.unsplash.com/photo-1505691723518-36a5ac3be353?auto=format&fit=crop&w=600&q=80',
    },
    {
      id: 'hurricane-rated',
      title: 'Hurricane Rated',
      desc: 'Resistencia certificada para huracanes.',
      image: 'https://images.unsplash.com/photo-1484154218962-a197022b5858?auto=format&fit=crop&w=600&q=80',
    },
  ],
};

const colorOptions = [
  { id: 'blanco', label: 'Blanco' },
  { id: 'negro', label: 'Negro' },
  { id: 'bronce', label: 'Bronce' },
  { id: 'custom', label: 'Personalizado' },
];

const glassOptions = [
  { id: 'clear', label: 'Clear' },
  { id: 'lowe', label: 'Low-E' },
  { id: 'laminado', label: 'Laminado acústico' },
  { id: 'reflectivo', label: 'Reflectivo' },
];

const finishOptions = [
  { id: 'mate', label: 'Mate' },
  { id: 'satinado', label: 'Satinado' },
  { id: 'texturizado', label: 'Texturizado' },
  { id: 'anodizado', label: 'Anodizado' },
];

const flattenDesignCatalog = () => {
  const result = [];
  Object.entries(designPresets).forEach(([categoryId, designs]) => {
    designs.forEach((design) => {
      result.push({
        categoryId,
        categoryName: getCategoryTitle(categoryId),
        ...design,
      });
    });
  });
  return result;
};

export {
  productCategories,
  designPresets,
  colorOptions,
  glassOptions,
  finishOptions,
  getCategoryTitle,
  flattenDesignCatalog,
};

